var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolReactangle = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Icons",
  preserveAspectRatio: "xMidYMid meet",
  style: {
    width: "100%",
    height: "auto"
  },
  viewBox: "0 0 32 32",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 3h4v4H3zM25 3h4v4h-4zM3 25h4v4H3zM25 25h4v4h-4zM5 7v18M27 7v18M7 5h18M7 27h18",
  className: "st0"
})));
export { SvgToolReactangle as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-reactangle.svg";